import type { IUserSessionContext } from '../../extViewmodels';
import { InternalAccountIds } from '../../models';

/**
 * Determines if the logged-in user is a reseller (non-internal account).
 * Internal users have accountIds in InternalAccountIds.
 *
 * @param userSession - The current user session context
 * @returns true if the user is a reseller, false if internal or no session
 */
export function isResellerSession(userSession: IUserSessionContext | null | undefined): boolean {
	const accountId = userSession?.account?.id;
	return accountId ? !InternalAccountIds.has(accountId) : false;
}
